import { computed, ref, Ref, watch } from "vue";
import { GenericField } from "@/business/shared/commons/validator/validatorsTypes";
import { RequiredRule } from "@/business/shared/commons/validator/rules/RequiredRule";
import { validator } from "@/business/shared/commons/validator/validator";
import { NumericRule } from "@/business/shared/commons/validator/rules/NumericRule";

export function createEditDeliveryValidator() {
  const client: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("El cliente es obligatorio")],
  });
  const name: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("El nombre de la entrega es obligatorio")],
  });
  const message: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [
      new RequiredRule(
        "El mensaje es obligatorio"
      ),
    ],
  });

  watch(
    () => client.value.val,
    () => {
      if ((client.value.val?.length ?? 0) > 0) {
        client.value.enabled = true;
      }
    }
  );
  watch(
    () => name.value.val,
    () => {
      if ((name.value.val?.length ?? 0) > 0) {
        name.value.enabled = true;
      }
    }
  );
  watch(
    () => message.value.val,
    () => {
      if ((message.value.val?.length ?? 0) > 0) {
        message.value.enabled = true;
      }
    }
  );

  function validate(field: GenericField, otherValue?: string): GenericField {
    return validator().validateField(field, otherValue);
  }

  const successForm = computed(() => {
    client.value = validate(client.value);
    name.value = validate(name.value);
    message.value = validate(message.value);

    return !(
      client.value.isSuccess &&
      name.value.isSuccess &&
      message.value.isSuccess
    );
  });

  function reset(): void {
    client.value.val = "";
    name.value.val = "";
    message.value.val = "";
    client.value.enabled = false;
    name.value.enabled = false;
    message.value.enabled = false;
  }

  return {
    client,
    name,
    message,
    successForm,
    reset,
  };
}
